import React, { useEffect, useState } from "react"
import { Drawer, Radio } from "antd"
import { useQuery } from "react-query"
import { useTranslation } from "react-i18next"
import { Button } from "../../../../components"
import { fetchLastmileXdocks } from "../../../../services"

export const BindXdockPanel = ({ open, zone, country, remediation, draftBindings, onAppend, onClose }) => {
  const { t } = useTranslation()
  const [selectedId, setSelectedId] = useState(null)

  // prefer xdocks from the remediation block; fall back to a live fetch
  const remediated = remediation?.missing_xdock_zones?.find((m) => m.zone === zone)?.available_xdocks
  const needsFetch = !remediated || remediated.length === 0

  const { data: fetched = [] } = useQuery(
    ["lastmile-xdocks-bind", country],
    () => fetchLastmileXdocks({ country, includeZones: true }),
    { enabled: open && needsFetch && Boolean(country), staleTime: 30_000 }
  )

  const xdocks = remediated && remediated.length > 0 ? remediated : fetched

  useEffect(() => {
    if (!open) setSelectedId(null)
  }, [open])

  const alreadyQueued = (draftBindings || []).filter((b) => b.zone_names?.includes(zone))

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={t("coberturas.createCoverages.bindXdock.title", { zone })}
      width={420}
      destroyOnClose
    >
      <p className="text-sm text-gray-600 mb-3">
        {t("coberturas.createCoverages.bindXdock.help", { zone, country })}
      </p>

      <Radio.Group value={selectedId} onChange={(e) => setSelectedId(e.target.value)} className="w-full">
        <div className="space-y-2">
          {xdocks.map((x) => (
            <Radio key={x.id} value={x.id} className="!flex w-full p-2 border rounded items-start">
              <div className="ml-2">
                <div className="font-semibold">{x.name}</div>
                <div className="text-xs text-gray-500">{x.country}</div>
                {x.zone_names && x.zone_names.length > 0 && (
                  <div className="text-xs text-gray-500 mt-1">
                    {t("coberturas.createCoverages.bindXdock.existingZones")}:&nbsp;
                    {x.zone_names.join(", ")}
                  </div>
                )}
              </div>
            </Radio>
          ))}
        </div>
      </Radio.Group>

      {alreadyQueued.length > 0 && (
        <div className="mt-4 text-xs text-gray-500">
          {t("coberturas.createCoverages.bindXdock.alreadyQueued", {
            xdocks: alreadyQueued.map((b) => `#${b.xdock_id}`).join(", "),
          })}
        </div>
      )}

      <div className="flex justify-end gap-2 mt-6">
        <Button onClick={onClose}>{t("common.cancel")}</Button>
        <Button
          type="primary"
          disabled={!selectedId}
          onClick={() => {
            onAppend(selectedId, [zone])
            setSelectedId(null)
          }}
        >
          {t("coberturas.createCoverages.bindXdock.add")}
        </Button>
      </div>
    </Drawer>
  )
}
